export const GET_SINGLE_DELIVERY_ORDER = "GET_SINGLE_DELIVERY_ORDER";
export const GET_SINGLE_PICKUP = "GET_SINGLE_PICKUP";
export const GET_ORDER_PICKUPS = "GET_ORDER_PICKUPS";
export const ADD_ORDER_PICKUP_PRICE = "ADD_ORDER_PICKUP_PRICE";
export const REMOVE_ORDER_PICKUP = "REMOVE_ORDER_PICKUP";
